//
//
//
//
import FormComponent from './form.vue';
export default {
  name: 'order-purchase-detail',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: {
    FormComponent: FormComponent
  }
};